'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clean = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _transmute = require('transmute');

var _relaxed = require('conversations-schema/sanitize/relaxed');

var _immutable = require('immutable');

var sanitizers = (0, _immutable.Map)();
var Sanitize = (0, _relaxed.setupSanitize)();

var _document$implementat = document.implementation.createHTMLDocument(''),
    element = _document$implementat.body;

var BLACKLISTED_STYLES = ['position', 'height', 'width', 'top', 'bottom', 'left', 'right', 'z-index', 'clear', 'float', 'display', 'visibility', 'opacity', 'background-image', 'white-space'];

var removeStyles = function removeStyles(_ref) {
  var node = _ref.node;

  if (node && node.style && node.style.length > 0 && node.style.removeProperty) {
    BLACKLISTED_STYLES.forEach(function (style) {
      return node.style.removeProperty(style);
    });
  }

  return null;
};

var clean = exports.clean = (0, _transmute.memoize)(function (text, config) {
  var div = document.createElement('div');

  if (text && text !== '') {
    var key = config || Sanitize.Config.RELAXED;

    element.innerHTML = text;

    if (!sanitizers.has(key)) {
      sanitizers = sanitizers.set(key, new Sanitize(_extends({}, key, {
        transformers: [removeStyles]
      })));
    }

    try {
      var sanitizer = sanitizers.get(key);
      var fragment = sanitizer.clean_node(element);
      div.appendChild(fragment.cloneNode(true));
    } catch (err) {
      console.error(err); // eslint-disable-line
    }
  }

  return div.innerHTML.replace('\n', '');
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/sanitize/index.js
// module id = 306
// module chunks = 0 1